class DropdownLinkList {
    constructor() {
        const dropdownTriggers = document.querySelectorAll('.dropdown-link-list__button');
        const toggleClass = "dropdown-link-list__button--expanded";

        dropdownTriggers.forEach(function (element) {
            element.addEventListener('click', function (e) {
                element.classList.toggle(toggleClass);
            });

            element.addEventListener('blur', function (e) {
                if (!element.parentElement.contains(e.relatedTarget)) {
                    element.classList.remove(toggleClass);
                }
            });
        });
    }
}

document.addEventListener("DOMContentLoaded", function () {
    new DropdownLinkList();
});